import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { listTasks, logout, type Task } from '../api';
import { StatusPill } from './StatusPill';

function timeAgo(ts: number): string {
  const s = Math.floor((Date.now() - ts) / 1000);
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
}

export function Sidebar({ username, onLogout }: { username: string; onLogout: () => void }) {
  const [tasks, setTasks] = useState<Task[]>([]);
  const location = useLocation();
  const navigate = useNavigate();

  async function handleLogout() {
    await logout();
    onLogout();
  }

  useEffect(() => {
    let cancelled = false;
    const load = () => {
      listTasks()
        .then((t) => !cancelled && setTasks(t))
        .catch(() => {});
    };
    load();
    const t = setInterval(load, 3000);
    return () => {
      cancelled = true;
      clearInterval(t);
    };
  }, [location.pathname]);

  return (
    <aside className="sidebar">
      <div className="sidebar-head">
        <div className="brand">
          <span className="brand-mark" />
          <span className="brand-name">Operator</span>
        </div>
        <div className="brand-tag">Voice agent — Gemini × Twilio</div>
      </div>

      <button className="new-call-btn" onClick={() => navigate('/')}>
        + New call
      </button>
      <button
        className="new-call-btn"
        style={{ marginTop: 0, background: 'transparent', color: 'var(--ink)', border: '1px solid var(--rule)' }}
        onClick={() => navigate('/mobile')}
      >
        ▦ Local bridge
      </button>

      <nav className="task-list">
        {tasks.length === 0 ? (
          <div className="task-list-empty">No calls yet.</div>
        ) : (
          tasks.map((t, idx) => {
            const num = String(tasks.length - idx).padStart(3, '0');
            const active = location.pathname.endsWith(`/${t.id}`);
            return (
              <Link
                key={t.id}
                to={`/tasks/${t.id}`}
                className={`task-row${active ? ' active' : ''}`}
              >
                <div className="task-row-top">
                  <span className="task-row-number">№ {num}</span>
                  <StatusPill status={t.status} />
                </div>
                <div className="task-row-instruction">{t.instruction}</div>
                <div className="task-row-time">{timeAgo(t.created_at)}</div>
              </Link>
            );
          })
        )}
      </nav>

      <div className="sidebar-foot">
        <div className="sidebar-user">
          <span className="sidebar-user-dot" />
          <span className="sidebar-user-name">{username}</span>
        </div>
        <button className="sidebar-logout" onClick={handleLogout} title="Sign out">
          Sign out
        </button>
      </div>
    </aside>
  );
}
